// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__3qwQx","upload":"Small_upload__1nX1Y","imageWrap":"Small_imageWrap__3dWOR","removeBtn":"Small_removeBtn__1vx6y"};